<template>
  <div>
    <b-alert
      :show="countdown"
      dismissible
      :variant="type"
      @dismissed="closeNotification"
      @dismiss-count-down="countDownChanged"
      class="notification"
    >
      {{notificationMessage}}<br/>
      This alert will dismiss after {{ countdown }} seconds...
    </b-alert>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
  export default {
    name: "notification",
    computed:{
      ...mapGetters(['notificationMessage','maxTime','countdown', 'type'])
    },
    methods: {
      ...mapMutations(['hideNotification','setCountdown']),
      countDownChanged(countdown) {
        this.setCountdown(countdown)
        if(countdown == 0) this.closeNotification()
      },
      closeNotification(){
        this.hideNotification()
      }
    }
  }
</script>
<style lang='css'>
.notification {
  margin-bottom: 0;
}
</style>
